import script from "./IonicMobileNavBar.vue?vue&type=script&setup=true&lang=js"
export * from "./IonicMobileNavBar.vue?vue&type=script&setup=true&lang=js"

import "./IonicMobileNavBar.vue?vue&type=style&index=0&id=92f0149e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92f0149e"]])

export default __exports__